export default function stringPropertyIsSet(value: string | undefined): boolean {
  return value !== undefined && value !== null && value !== '';
}
